export const SCHEDULE_COLUMN_KEY = 'schedule'
